<div
  class="calendar-timeline flex-1 min-h-0"
  [class.slot-click-enabled]="slotClickEnabled()"
>
  <full-calendar #calendar [options]="calendarOptions()" />
  @if (quickAddMenuEnabled()) {
    <siat-quick-add-menu
      [options]="quickAddMenuOptions()"
      (optionSelected)="onQuickAddOptionClick($event)"
    />
  }
</div>
